import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=56b8fc22&"
import script from "./QuoteHeader.vue?vue&type=script&lang=js&"
export * from "./QuoteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b8fc22')) {
      api.createRecord('56b8fc22', component.options)
    } else {
      api.reload('56b8fc22', component.options)
    }
    module.hot.accept("./QuoteHeader.vue?vue&type=template&id=56b8fc22&", function () {
      api.rerender('56b8fc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/quote-header/QuoteHeader.vue"
export default component.exports